export const ACTIVATION_GLOSSARY = [
  {
    key: 'activation.cardWindow',
    label: 'Janela dos cartões',
    whatIs: 'Escolhe até quantos dias depois da venda os quatro cartões contam: D15, D30 ou D60. O D0 é o dia da primeira venda.',
    purpose: 'Ler a implantação no prazo certo: D15 mostra o arranque, D30 é a referência da ativação e D60 mostra quem ainda engrena depois do primeiro mês.',
    howGenerated: 'A escolha fica só nesta sessão do navegador. Cada cartão conta apenas as empresas cuja janela escolhida já fechou e foi gravada pelo processamento da madrugada.',
    seeAlso: ['activation.windowPending'],
  },
  {
    key: 'activation.cardStarted',
    label: 'Iniciaram o uso',
    whatIs: 'Parte das empresas vendidas que cadastrou pelo menos um colaborador com perfil de funcionário até D+15, D+30 ou D+60 (o dono da conta não conta).',
    purpose: 'É o primeiro sinal de implantação: quem não cadastrou ninguém ainda não começou e é a prioridade do contato de implantação.',
    howGenerated: 'Empresas com o marco até a janela, divididas pelas vendidas com a janela fechada e gravada, menos as expurgadas. Retrato noturno dos bancos dos clientes, dia de Brasília.',
    metricKey: 'onboarding_started',
    seeAlso: ['activation.windowPending', 'activation.milestone'],
  },
  {
    key: 'activation.cardPunch',
    label: 'Bateram ponto',
    whatIs: 'Parte das empresas vendidas em que algum colaborador fez a 1ª batida de ponto (não excluída) até D+15 ou D+60.',
    purpose: 'Mostra quem passou do cadastro ao uso real do ponto, que é o valor principal do produto.',
    howGenerated: 'Empresas com batida de colaborador até a janela, divididas pelas que têm a janela fechada, gravada e a batida medida. Batida feita no trial conta como D+0. Dia de Brasília.',
    metricKey: 'onboarding_milestone_rate',
    seeAlso: ['activation.cardPunch30'],
  },
  {
    key: 'activation.cardPunch30',
    label: 'Bateram ponto até D+30 (ativação em 30 dias)',
    whatIs: 'Parte das empresas vendidas em que algum colaborador fez a 1ª batida de ponto (não excluída) até 30 dias depois da venda. É a ativação em 30 dias da Visão geral.',
    purpose: 'É o indicador principal de implantação: abaixo do esperado, o problema está entre a venda e o primeiro uso.',
    howGenerated: 'Vendidas com batida até D0 + 30, divididas pelas vendidas com a janela de 30 dias fechada, gravada e a batida medida; expurgadas ficam fora. Batida no trial conta como D+0. Dia de Brasília.',
    caveat: 'A Visão geral usa as vendas de 30 dias antes do período; aqui vale o período de vendas escolhido, então os números só batem com o mesmo recorte.',
    metricKey: 'activation_rate_30d',
    seeAlso: ['activation.cardPunch'],
  },
  {
    key: 'activation.cardValue',
    label: 'Primeiro valor',
    whatIs: 'Parte das empresas vendidas em que o ponto entrou em operação até a janela: em algum período de 7 dias, batida em 3 dias ou mais e de pelo menos metade dos colaboradores cadastrados.',
    purpose: 'Separa quem só testou a batida de quem passou a usar o ponto com a equipe, que é quando o cliente percebe valor.',
    howGenerated: 'Para cada dia até D+N, o processamento noturno olha os 7 dias até ele: dias com batida e colaboradores que bateram contra os cadastrados até ali (mínimo 1). Dia de Brasília.',
    metricKey: 'first_value_rate',
    seeAlso: ['activation.cardHabit'],
  },
  {
    key: 'activation.cardHabit',
    label: 'Rotina',
    whatIs: 'Parte das empresas vendidas em que o ponto virou hábito na semana que fecha a janela (de D+N-6 a D+N): batida em 4 dias ou mais e de pelo menos metade dos colaboradores cadastrados.',
    purpose: 'Mostra quem manteve o uso depois de começar; quem teve primeiro valor e perdeu a rotina pede acompanhamento.',
    howGenerated: 'Conta, na semana de D+N-6 a D+N, os dias com batida de colaborador e quem bateu, contra os cadastrados até D+N (mínimo 1). Gravado uma vez, quando a janela fecha. Dia de Brasília.',
    metricKey: 'habit_rate',
    seeAlso: ['activation.cardValue'],
  },
  {
    key: 'activation.userActivation',
    label: 'Ativação de usuário (7 dias)',
    whatIs: 'Parte dos usuários criados na empresa que concluíram a 1ª ação de uso real em até 7 dias depois de criados.',
    purpose: 'Mostra se as pessoas cadastradas de fato começam a usar ou ficam paradas depois do convite.',
    howGenerated: 'Criados com 1ª ação de uso real (batida, ajuste, aprovação, documento) em até 7 dias ÷ criados que já completaram 7 dias, desde a criação da empresa. Criados antes do início da coleta ficam fora.',
    metricKey: 'user_activation_7d',
  },
  {
    key: 'activation.milestoneGroup',
    label: 'Grupo do marco',
    whatIs: 'Fase da implantação a que o marco pertence: Setup (cadastro e configuração), Valor (uso do ponto) ou Hábito (uso repetido). Quantidades são medianas por empresa.',
    purpose: 'Agrupa os marcos na ordem natural da implantação, para ver em que fase a carteira trava.',
    howGenerated: 'Fixado no catálogo de marcos da ativação; não muda por empresa.',
  },
  {
    key: 'activation.milestone',
    label: 'Marco',
    whatIs: 'Passo concreto da implantação, como cadastrar colaboradores, configurar turno, fazer a 1ª batida ou o 1º espelho. O selo "gargalo" marca o destino das piores conversões entre etapas.',
    purpose: 'Diz o que exatamente a empresa já fez, para o time de implantação saber qual é o próximo passo.',
    howGenerated: 'Lido nos bancos dos clientes pelo processamento noturno. Turno, equipe e cerco criados no 1º minuto da empresa (cadastro automático) não contam. Marco feito no trial conta como D+0.',
    caveat: 'As regras de ponto da empresa (tolerância, horas extras, banco de horas) não são medidas.',
    seeAlso: ['activation.windowRate', 'activation.bottleneck'],
  },
  {
    key: 'activation.windowRate',
    label: 'Marco até D+15, D+30 e D+60',
    whatIs: 'Parte das empresas vendidas que atingiram o marco até 15, 30 ou 60 dias depois da venda, com a contagem "atingiram de base" logo abaixo.',
    purpose: 'Mostra a evolução de cada marco ao longo do tempo. Clicar na célula lista as empresas que não chegaram, para contato.',
    howGenerated: 'Atingiram ÷ base, em que a base são as vendidas com a janela fechada (D+N+1), gravada e o marco medido. Retrato noturno dos bancos dos clientes, dia de Brasília.',
    caveat: 'Cada coluna tem a própria base: empresas com a janela ainda aberta ficam fora e aparecem na nota abaixo da matriz.',
    metricKey: 'onboarding_milestone_rate',
    seeAlso: ['activation.base', 'activation.windowPending', 'activation.notMeasured'],
  },
  {
    key: 'activation.reached',
    label: 'Atingiram',
    whatIs: 'Quantas empresas da base atingiram o marco até a janela.',
    purpose: 'É o numerador da taxa; com a base, mostra se a porcentagem vem de muitas ou de poucas empresas.',
    howGenerated: 'Contagem das empresas com a janela gravada em que o marco tem data até D+N. Marco feito antes da venda conta como D+0.',
    seeAlso: ['activation.base'],
  },
  {
    key: 'activation.base',
    label: 'Base da janela',
    whatIs: 'Empresas vendidas cuja janela já fechou e foi gravada (e, num marco, em que o marco foi medido). É o denominador das taxas da Ativação.',
    purpose: 'Diz sobre quantas empresas a porcentagem foi calculada; base pequena oscila muito de um mês para o outro.',
    howGenerated: 'A janela fecha em D+N+1 e é gravada uma vez pelo processamento da madrugada. Ficam fora as em andamento, as aguardando medição, as expurgadas e as de marco não medido.',
    seeAlso: ['activation.windowPending', 'activation.notMeasured', 'activation.purged'],
  },
  {
    key: 'activation.notMeasured',
    label: 'Não medidas',
    whatIs: 'Empresas com a janela fechada em que o marco não pôde ser lido, em geral por falta de índice no banco do cliente.',
    purpose: 'Mostra quanto da base ficou de fora por limitação da leitura, e não por falta de uso.',
    howGenerated: 'O processamento noturno pula a leitura que exigiria varrer uma tabela inteira do cliente; o marco fica sem medição e sai só do denominador daquele marco.',
    caveat: 'O marco de espelho ou fechamento nunca fica sem medição.',
  },
  {
    key: 'activation.quantity',
    label: 'Quantidades por janela',
    whatIs: 'Medianas (e o percentil 75, valor que 75% das empresas não passam) de colaboradores cadastrados, dias com batida e quem bateu na semana da janela, e a relação entre cadastrados e assentos.',
    purpose: 'Mostra o tamanho típico da implantação em cada janela, para separar empresa pequena de empresa travada.',
    howGenerated: 'Calculadas sobre as empresas com a janela gravada. Os assentos são os contratados hoje; "80% ou mais" é a parte das empresas com cadastrados ÷ assentos de 0,8 ou mais.',
  },
  {
    key: 'activation.bottleneck',
    label: 'Gargalo',
    whatIs: 'As duas piores conversões entre etapas seguidas em D30 e em D60, com base de 20 empresas ou mais. Na matriz, o selo marca o marco de destino dessas conversões.',
    purpose: 'Aponta onde a carteira mais perde empresas na implantação, para priorizar material e contato naquela passagem.',
    howGenerated: 'Para cada etapa k, conversão = empresas na etapa k+1 ou além ÷ empresas na etapa k ou além, entre as de janela gravada. As duas menores de cada janela viram gargalo.',
    seeAlso: ['activation.conversion'],
  },
  {
    key: 'activation.window',
    label: 'Janela',
    whatIs: 'Até quantos dias depois da venda o número conta: D15, D30 ou D60 (D0 é o dia da primeira venda).',
    purpose: 'Compara o avanço da mesma carteira em prazos diferentes.',
    howGenerated: 'A janela de N dias vai de D0 a D0 + N no dia de Brasília e fecha no dia seguinte; só então é gravada.',
  },
  {
    key: 'activation.stageWindow',
    label: 'Etapa até a janela',
    whatIs: 'Etapa mais avançada que a empresa atingiu até D+15, D+30 ou D+60: 0 sem colaborador, 1 colaboradores, 2 turno ou escala, 3 bateu ponto, 4 em operação, 5 rotina.',
    purpose: 'Mostra onde as empresas param. Clicar num segmento das barras lista as empresas daquela etapa.',
    howGenerated: 'Gravada com a janela. Cada etapa implica as anteriores; quem bateu ponto sem configurar turno fica na etapa 3 com "pulou a configuração".',
    metricKey: 'onboarding_stage',
    seeAlso: ['activation.stageCompanies'],
  },
  {
    key: 'activation.stageCompanies',
    label: 'Empresas na etapa',
    whatIs: 'Quantas empresas pararam em cada etapa até a janela e a participação delas sobre as empresas com a janela gravada.',
    purpose: 'Dá o tamanho de cada grupo para planejar o contato: muitas em "sem colaborador" pedem ação diferente de muitas em "bateu ponto".',
    howGenerated: 'Contagem por etapa entre as vendidas com a janela gravada e a batida medida; participação = empresas da etapa ÷ esse total.',
    caveat: 'Empresas em que a batida não pôde ser lida ficam fora e aparecem como não medidas.',
  },
  {
    key: 'activation.conversion',
    label: 'Conversão entre etapas',
    whatIs: 'Parte das empresas que chegaram a uma etapa e avançaram para a seguinte até a janela.',
    purpose: 'Mede a passagem entre duas etapas sem a influência das anteriores, para achar o ponto exato em que a implantação trava.',
    howGenerated: 'Empresas na etapa seguinte ou além ÷ empresas na etapa de origem ou além, entre as vendidas com a janela de 30 ou 60 dias gravada.',
    metricKey: 'onboarding_stage',
    seeAlso: ['activation.bottleneck', 'activation.conversionBase'],
  },
  {
    key: 'activation.conversionBase',
    label: 'Base e perda da conversão',
    whatIs: 'Base: empresas que chegaram à etapa de origem. Não avançaram: as que ficaram nela até a janela.',
    purpose: 'Mostra quantas empresas há para recuperar naquela passagem.',
    howGenerated: 'Contadas entre as vendidas com a janela gravada; só conversões com base de 20 empresas ou mais viram gargalo.',
  },
  {
    key: 'activation.timeReached',
    label: 'Atingiram até D+60',
    whatIs: 'Quantas empresas com a janela de 60 dias gravada atingiram o marco até D+60, entre as que têm o marco medido.',
    purpose: 'Mostra a base sobre a qual a mediana e o percentil 75 do tempo foram calculados.',
    howGenerated: 'Lido das janelas de 60 dias gravadas pelo processamento noturno; marco feito antes da venda conta como D+0.',
  },
  {
    key: 'activation.timeMedian',
    label: 'Mediana de dias até o marco',
    whatIs: 'Dias entre a venda e o marco para a empresa do meio: metade das que atingiram levou até esse tempo.',
    purpose: 'Diz o prazo típico de cada passo, para combinar expectativa com o cliente e achar quem está atrasado.',
    howGenerated: 'Dias de D0 até a data do marco, só entre as empresas com D+60 gravado que atingiram o marco até D+60. Dia de Brasília.',
    caveat: 'Quem não atingiu o marco não entra: a mediana mede o ritmo de quem chegou, não o de toda a carteira.',
    seeAlso: ['activation.timeP75'],
  },
  {
    key: 'activation.timeP75',
    label: 'Percentil 75 de dias até o marco',
    whatIs: 'Dias até o marco que 75% das empresas que o atingiram não passaram (p75).',
    purpose: 'Mostra o prazo das mais lentas sem deixar casos extremos distorcerem o número.',
    howGenerated: 'Mesma base da mediana: empresas com D+60 gravado que atingiram o marco até D+60, dias contados de D0.',
    seeAlso: ['activation.timeMedian'],
  },
  {
    key: 'activation.timeToValue',
    label: 'Dias até o primeiro valor',
    whatIs: 'Distribuição das empresas pelo tempo entre a venda e o primeiro valor (ponto em operação): 0 a 3, 4 a 7, 8 a 14, 15 a 30, 31 a 60 dias ou não atingiu até D+60.',
    purpose: 'Mostra se o valor chega rápido para a maioria ou se há uma cauda longa de empresas lentas ou paradas.',
    howGenerated: 'Empresas com a janela de 60 dias gravada e a batida medida; participação = empresas da faixa ÷ total delas. Dia de Brasília.',
    metricKey: 'time_to_first_value',
  },
  {
    key: 'activation.cohortIndicator',
    label: 'Indicador das coortes',
    whatIs: 'Qual marco a tabela e o gráfico de coortes mostram em D15, D30 e D60: iniciou, bateu ponto, primeiro valor, rotina ou espelho.',
    purpose: 'Compara as turmas de venda no marco que interessa, sem misturar indicadores numa tabela só.',
    howGenerated: 'A escolha fica só nesta sessão do navegador. A taxa de cada coorte usa só as empresas com a janela fechada e gravada.',
  },
  {
    key: 'activation.cohort',
    label: 'Coorte de venda',
    whatIs: 'Grupo das empresas vendidas no mesmo mês (ou trimestre, conforme o filtro Coorte), pela data da primeira venda. O selo "amostra pequena" marca coortes com menos de 20 empresas.',
    purpose: 'Compara turmas de venda: mostra se a implantação das vendas recentes está melhor ou pior que a das antigas.',
    howGenerated: 'Cada empresa entra na coorte do mês ou trimestre do seu D0, no dia de Brasília. A tabela mostra a mais recente primeiro.',
    seeAlso: ['activation.smallSample'],
  },
  {
    key: 'activation.cohortSize',
    label: 'Empresas da coorte',
    whatIs: 'Quantas empresas entram na coorte. Com o universo padrão são as vendidas; em Todas ou Não vendidas, a coluna vira Empresas e mostra também quantas foram vendidas.',
    purpose: 'Dá o tamanho da turma, para saber quanto pesa cada ponto percentual.',
    howGenerated: 'Contagem das empresas com D0 no mês ou trimestre, com os filtros da Ativação aplicados; inclui as expurgadas, que ficam fora só das taxas.',
    seeAlso: ['activation.purged'],
  },
  {
    key: 'activation.purged',
    label: 'Expurgadas',
    whatIs: 'Empresas excluídas sem nenhum registro no banco, nem o turno que nasce com a empresa.',
    purpose: 'Separa cadastro descartado de implantação que falhou: expurgada não conta como fracasso.',
    howGenerated: 'Detectado pelo processamento noturno quando a empresa está excluída e não tem nenhum dado de criação; sai de todos os denominadores.',
  },
  {
    key: 'activation.smallSample',
    label: 'Amostra pequena',
    whatIs: 'Coorte com menos de 20 empresas medidas (sem as expurgadas).',
    purpose: 'Avisa que a porcentagem pode mudar muito com uma ou duas empresas; compare com cuidado ou use coorte por trimestre.',
    howGenerated: 'Calculado pelo servidor em cada coorte: empresas da coorte menos as expurgadas, abaixo de 20.',
  },
  {
    key: 'activation.cohortWindow',
    label: 'Indicador da coorte até D+N',
    whatIs: 'Parte das empresas da coorte que atingiram o indicador escolhido até D+15, D+30 ou D+60, com "atingiram de base" abaixo.',
    purpose: 'Compara as coortes no mesmo prazo depois da venda.',
    howGenerated: 'Atingiram ÷ empresas da coorte com a janela fechada, gravada e o marco medido. Enquanto a janela não fecha para todas, aparece "em andamento" ou "aguardando medição".',
    seeAlso: ['activation.windowPending', 'activation.cohortIndicator'],
  },
  {
    key: 'activation.windowPending',
    label: 'Em andamento e aguardando medição',
    whatIs: 'Em andamento: empresas cuja janela ainda não fechou. Aguardando medição: janela fechada que o processamento da madrugada ainda não gravou.',
    purpose: 'Mostra quantas empresas ainda vão entrar na conta; uma coorte com muitas pendentes ainda vai mudar.',
    howGenerated: 'A janela fecha em D+N+1. A gravação espera o retrato das empresas cobrir D+N e a leitura dos marcos terminar sem erro. As duas ficam fora do denominador.',
  },
  {
    key: 'activation.cohortRetroactive',
    label: 'Janelas retroativas',
    whatIs: 'Parte das janelas da coorte que foram gravadas depois do prazo normal (mais de 3 dias após o fechamento), a partir do histórico.',
    purpose: 'Indica quanto da coorte foi reconstituído depois, por exemplo na carga inicial, e não medido na hora.',
    howGenerated: 'Janela gravada até D+N+3 conta como ao vivo; depois disso, como retroativa. Participação = retroativas ÷ janelas gravadas das empresas medidas.',
    seeAlso: ['common.state.derived'],
  },
  {
    key: 'activation.cohortMedianPunch',
    label: 'Mediana de dias até a 1ª batida',
    whatIs: 'Dias entre a venda e a 1ª batida de colaborador para a empresa do meio da coorte, entre as que bateram até D+30.',
    purpose: 'Mostra se as vendas recentes começam a usar o ponto mais rápido que as antigas.',
    howGenerated: 'Mediana dos dias de D0 até a 1ª batida, entre as empresas com a janela de 30 dias gravada que bateram até D+30. Batida no trial conta como 0. Dia de Brasília.',
    metricKey: 'time_to_activation',
  },
  {
    key: 'activation.cohortMedianEmployees',
    label: 'Colaboradores em D30 (mediana)',
    whatIs: 'Número de colaboradores cadastrados até D+30 na empresa do meio da coorte.',
    purpose: 'Mostra o tamanho típico das implantações da coorte, para comparar turmas de clientes parecidos.',
    howGenerated: 'Mediana dos colaboradores com perfil de funcionário cadastrados até o fim de D+30, entre as empresas com a janela de 30 dias gravada.',
  },
  {
    key: 'activation.soldAt',
    label: 'Vendida em (D0)',
    whatIs: 'Dia da primeira venda da empresa, o D0 da Ativação. "D0 aproximado" indica que veio do 1º pagamento ou da criação; "não vendida" indica que não há venda.',
    purpose: 'É o ponto de partida de todos os prazos da implantação.',
    howGenerated: 'Primeira data achada: registro de venda no Master, funcionalidade liberada na venda inicial, 1º pagamento ou criação (se hoje não é trial nem grátis). Dia de Brasília; antes da criação vale a criação.',
    seeAlso: ['activation.soldSource'],
  },
  {
    key: 'activation.soldSource',
    label: 'Fonte da venda',
    whatIs: 'De onde veio a data da venda (D0): venda registrada no Master, liberação de funcionalidade da venda, 1º pagamento, criação da empresa paga ou não vendida.',
    purpose: 'Diz o quanto confiar no D0: pagamento e criação são aproximações.',
    howGenerated: 'Lida pelo processamento noturno nos bancos dos clientes, nessa ordem de prioridade; a venda é relida enquanto a empresa tem até 180 dias e nenhum registro de venda.',
  },
  {
    key: 'activation.trialDays',
    label: 'Dias de trial',
    whatIs: 'Dias entre a criação da empresa e a primeira venda; zero é venda direta.',
    purpose: 'Separa quem testou antes de comprar de quem comprou sem testar.',
    howGenerated: 'Diferença em dias entre a criação e o D0, no dia de Brasília.',
  },
  {
    key: 'activation.daysSinceSale',
    label: 'Dias desde a venda (D+)',
    whatIs: 'Quantos dias se passaram desde a primeira venda até hoje.',
    purpose: 'Mostra a idade da implantação, para comparar o que a empresa fez com o prazo esperado.',
    howGenerated: 'Hoje menos o D0, no dia de Brasília; nunca negativo.',
  },
  {
    key: 'activation.stageNow',
    label: 'Etapa hoje',
    whatIs: 'Etapa mais avançada que a empresa atingiu até hoje: 0 sem colaborador, 1 colaboradores, 2 turno ou escala, 3 bateu ponto, 4 em operação, 5 rotina nos últimos 7 dias.',
    purpose: 'Diz em que ponto da implantação a empresa está agora. Também filtra a lista de empresas travadas.',
    howGenerated: 'Calculada na leitura com os marcos gravados pelo processamento noturno; rotina usa as batidas dos 7 dias até ontem. "Pulou a configuração" marca quem bateu ponto sem turno.',
    seeAlso: ['activation.stageWindow'],
  },
  {
    key: 'activation.skippedSetup',
    label: 'Pulou a configuração',
    whatIs: 'A empresa bateu ponto sem ter configurado turno ou escala.',
    purpose: 'Avisa que o ponto está em uso sem regra de jornada: os cálculos de horas podem estar errados para o cliente.',
    howGenerated: 'Marcado quando a etapa é 3 ou mais e o marco de turno ou escala está medido e não foi atingido.',
  },
  {
    key: 'activation.stuckReason',
    label: 'Motivo da trava',
    whatIs: 'Por que a empresa vendida está travada: sem colaboradores, sem turno ou escala, sem batida, ponto não decolou, parou de bater ou cadastro incompleto. Vale o primeiro motivo do trilho que se aplica.',
    purpose: 'Diz o que precisa acontecer para a implantação andar e organiza a fila de contato por problema.',
    howGenerated: 'Regra aplicada na leitura sobre os marcos de hoje, para empresas vendidas, não canceladas nem excluídas, de D+0 a D+75. Cada motivo tem um prazo: 10, 15, 21, 30 ou 7 dias.',
    seeAlso: ['activation.overdueDays', 'activation.nextStep'],
  },
  {
    key: 'activation.situation',
    label: 'Situação na ativação',
    whatIs: 'Como a empresa está no acompanhamento: travada (com o motivo, o próximo passo e o atraso), em dia, não vendida ou fora do acompanhamento (cancelada, excluída ou depois de D+75).',
    purpose: 'Diz numa palavra se a implantação da empresa precisa de ação agora.',
    howGenerated: 'Regra das empresas travadas aplicada aos marcos de hoje; só vendidas, não canceladas nem excluídas, de D+0 a D+75, podem estar travadas.',
    seeAlso: ['activation.stuckReason'],
  },
  {
    key: 'activation.overdueDays',
    label: 'Atrasada há',
    whatIs: 'Quantos dias a empresa passou do prazo do motivo da trava.',
    purpose: 'Ordena a fila de contato: quanto maior o atraso, mais urgente.',
    howGenerated: 'Dias desde a venda menos o prazo do motivo; em "Parou de bater", dias desde a última batida menos 7. Prazos: sem colaboradores 10, sem turno 15, sem batida 21, não decolou e cadastro incompleto 30.',
    seeAlso: ['activation.stuckReason'],
  },
  {
    key: 'activation.nextStep',
    label: 'Próximo passo',
    whatIs: 'Ação sugerida para destravar a empresa, de acordo com o motivo, com números da própria empresa quando existem.',
    purpose: 'Dá ao time de implantação o que dizer no contato, sem precisar abrir a conta antes.',
    howGenerated: 'Texto montado pelo servidor a partir do motivo, como "Completar o cadastro (8 de 30)" com os habilitados e os assentos de hoje.',
  },
  {
    key: 'activation.windowValues',
    label: 'Valores na janela',
    whatIs: 'O que a empresa tinha até a janela escolhida: colaboradores cadastrados, dias com batida e quem bateu na semana da janela, e a etapa atingida.',
    purpose: 'Explica por que a empresa está ou não na célula clicada, com os números do dia da janela, e não os de hoje.',
    howGenerated: 'Gravado uma vez pelo processamento da madrugada quando a janela fecha. Antes disso aparece "em andamento" ou "aguardando medição".',
    seeAlso: ['activation.windowWeek', 'activation.windowStage'],
  },
  {
    key: 'activation.windowWeek',
    label: 'Semana da janela',
    whatIs: 'Na semana de D+N-6 a D+N: em quantos dias houve batida de colaborador e quantos colaboradores bateram, comparado aos cadastrados.',
    purpose: 'Mostra se o ponto estava em uso pela equipe no fim da janela, a base da rotina.',
    howGenerated: 'Batidas não excluídas de usuários com perfil de funcionário, pelo dia do ponto, lidas nos bancos dos clientes e gravadas com a janela.',
  },
  {
    key: 'activation.windowStage',
    label: 'Etapa na janela',
    whatIs: 'Etapa mais avançada atingida até a janela (0 a 5), ou "em andamento" e "aguardando medição" quando a janela ainda não foi gravada.',
    purpose: 'Compara a etapa no prazo com a etapa de hoje.',
    howGenerated: 'Gravada com a janela pelo processamento da madrugada; não muda depois.',
    seeAlso: ['activation.stageNow'],
  },
  {
    key: 'activation.windowRecording',
    label: 'Gravação da janela',
    whatIs: 'Situação da janela da empresa: gravada no fechamento, retroativa (gravada depois do prazo), aguardando medição ou em andamento.',
    purpose: 'Diz se os números da linha já são definitivos.',
    howGenerated: 'Gravada até 3 dias depois do fechamento é "no fechamento"; depois disso é retroativa. Uma vez gravada, não muda.',
  },
  {
    key: 'activation.windowManagers',
    label: 'Gestores ou admins na janela',
    whatIs: 'Quantas pessoas, além do dono, tinham papel de gestão até a janela: admin secundário, outro admin ou funcionário responsável por equipe.',
    purpose: 'Mostra se a empresa distribuiu a operação do ponto ou se depende de uma pessoa só.',
    howGenerated: 'Contadas no cadastro de usuários pelo dia de criação até o fim de D+N, no processamento da madrugada.',
  },
  {
    key: 'activation.windowPunchDays',
    label: 'Dias com batida até a janela',
    whatIs: 'Em quantos dias diferentes, de D0 até D+N, houve batida de colaborador.',
    purpose: 'Mostra se o uso foi contínuo ou só pontual durante a implantação.',
    howGenerated: 'Dias distintos com batida não excluída de usuário com perfil de funcionário, de D0 a D+N, pelo dia do ponto.',
  },
  {
    key: 'activation.seats',
    label: 'Habilitados ÷ assentos',
    whatIs: 'Usuários habilitados hoje (funcionários e gestores) divididos pelos assentos contratados, com os colaboradores cadastrados abaixo.',
    purpose: 'Mostra se a empresa cadastrou quem pagou: abaixo de 50% depois de 30 dias vira "cadastro incompleto".',
    howGenerated: 'Habilitados e assentos do retrato noturno mais recente da empresa. Sem assentos contratados, mostra só os habilitados.',
    seeAlso: ['common.seatsContracted', 'activation.employeesRegistered'],
  },
  {
    key: 'activation.employeesRegistered',
    label: 'Cadastrados',
    whatIs: 'Colaboradores com perfil de funcionário que já foram cadastrados na empresa, contando os desligados depois.',
    purpose: 'É a base da implantação: primeiro valor e rotina comparam quem bateu com esse número.',
    howGenerated: 'Contados no cadastro de usuários lido pelo PI; quem é desabilitado continua contando.',
  },
  {
    key: 'activation.employeesNow',
    label: 'Habilitados hoje',
    whatIs: 'Usuários funcionários e gestores habilitados hoje na empresa.',
    purpose: 'Comparado aos assentos, mostra quanto do contrato está em uso no cadastro.',
    howGenerated: 'Lido do retrato noturno mais recente da empresa.',
  },
  {
    key: 'activation.punches',
    label: '1ª e última batida',
    whatIs: 'Datas da primeira e da última batida de colaborador na empresa.',
    purpose: 'Mostra quando o uso do ponto começou e se ainda continua.',
    howGenerated: 'Batidas não excluídas de usuários com perfil de funcionário, pelo dia do ponto, inclusive as lançadas pelo admin ou pelo sistema. Lidas pelo processamento noturno.',
  },
  {
    key: 'activation.punch7d',
    label: 'Batida nos últimos 7 dias',
    whatIs: 'Em quantos dias houve batida de colaborador e quantos colaboradores bateram nos 7 dias até ontem.',
    purpose: 'Mostra o uso atual da empresa: é a base da etapa de rotina hoje e do motivo "parou de bater".',
    howGenerated: 'Batidas não excluídas de usuários com perfil de funcionário, de 7 dias atrás até ontem, pelo dia do ponto; calculado no processamento noturno.',
  },
  {
    key: 'activation.adminLastActive',
    label: 'Último acesso de admin',
    whatIs: 'Último dia em que algum administrador da empresa abriu o sistema ou fez uma ação.',
    purpose: 'Mostra se quem implanta continua acompanhando; admin sumido costuma anteceder a trava.',
    howGenerated: 'Maior dia com atividade ou sessão de usuário com papel de admin nos agregados diários do PI, no dia local da empresa; atualizado toda madrugada.',
  },
  {
    key: 'activation.lastProgress',
    label: 'Último avanço',
    whatIs: 'Data do marco mais recente que a empresa atingiu (cadastro, gestor, turno, escala, equipe, cerco, MarQTab ou REP (relógio de ponto), batida, primeiro valor ou espelho).',
    purpose: 'Mostra há quanto tempo a implantação não anda.',
    howGenerated: 'Maior data entre os marcos gravados até hoje, recalculada toda madrugada até D+95.',
  },
  {
    key: 'activation.featuresUsed30d',
    label: 'Funcionalidades em 30 dias',
    whatIs: 'Quantas funcionalidades diferentes a empresa usou nos 30 dias até ontem.',
    purpose: 'Mostra se o uso vai além do ponto.',
    howGenerated: 'Funcionalidades distintas com alguma ação nos agregados diários do PI, de 30 dias atrás até ontem.',
  },
  {
    key: 'activation.profile',
    label: 'Plano, porte e jornada',
    whatIs: 'Plano (trial, grátis, até 10 ou acima de 10 funcionários), porte, jornada do cliente e perfil da empresa, todos como estão hoje.',
    purpose: 'Contextualiza a implantação: empresa pequena e em trial tem ritmo diferente de empresa grande e paga.',
    howGenerated: 'Lidos do retrato mais recente do cadastro da empresa.',
    caveat: 'É o estado de hoje, não o da época da venda.',
    seeAlso: ['common.sizeBand', 'common.journey', 'common.segment'],
  },
  {
    key: 'activation.origin',
    label: 'Origem do cadastro',
    whatIs: 'Por onde a empresa foi criada: pelo Master (time) ou pela landing page (o próprio cliente no site).',
    purpose: 'Compara a implantação de quem foi cadastrado pelo time com a de quem chegou sozinho.',
    howGenerated: 'Lida do campo de origem do cadastro da empresa no retrato mais recente.',
  },
  {
    key: 'activation.statusNow',
    label: 'Situação hoje',
    whatIs: 'Situação atual da empresa: ativa, cancelada ou excluída, vendida sem pagar (ainda em trial) ou em trial para as não vendidas.',
    purpose: 'Mostra se uma implantação ruim terminou em cancelamento.',
    howGenerated: 'Do retrato mais recente: excluída ou inativa é cancelada; em trial é vendida sem pagar (ou em trial, se não houve venda); o resto é ativa.',
  },
];



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/glossary/activation.js